export enum VERIFICATION_STATE {
  AUTHORIZED = 'AUTHORIZED',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  PENDING = 'PENDING'
}